import { useState } from 'react';
import { useSelector } from 'react-redux';
import AdminNonMemberWarning from './AdminNonMemberWarning';
import { getIsAdminNotMemberOfInbox } from '../selectors/getIsAdminNotMemberOfInbox';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const [showWarning, setShowWarning] = useState(true);
  const hideWarning = () => setShowWarning(false);
  const isAdminNotMemberOfInbox = Boolean(useSelector(getIsAdminNotMemberOfInbox));
  return {
    showWarning,
    hideWarning,
    isAdminNotMemberOfInbox
  };
};
const InboxWarningBanner = () => {
  const {
    showWarning,
    hideWarning,
    isAdminNotMemberOfInbox
  } = InboxWarningBanner.useComponent();
  if (showWarning && isAdminNotMemberOfInbox) {
    return /*#__PURE__*/_jsx(AdminNonMemberWarning, {
      closeWarning: hideWarning
    });
  }
  return null;
};
InboxWarningBanner.displayName = 'InboxWarningBanner';
InboxWarningBanner.useComponent = useComponent;
export default InboxWarningBanner;